import * as z from 'zod/v4'

const Role = z.enum(['user', 'cast'])

const Profile = z.object({
  profile: z.string(),
  job: z.string(),
  tastes: z.string(),
  now: z.string()
})
export type Profile = z.infer<typeof Profile>

export const ReturnSession = z.object({
  name: z.string(),
  icon: z.string(),
  channel: z.string(),
  profile: Profile.optional(),
  token: z.string(),
})
export type ReturnSession = z.infer<typeof ReturnSession>

export const User = z.object({
  name: z.string().min(1).max(20),
  role: Role,
  icon: z.string(),
  email: z.union([z.email(), z.literal('')]), // 通知用
  notification: z.boolean().default(false),
  profile: Profile,
  created_at: z.date(),
  terms_agree_version: z.number().int().default(0),
  stripe_customer_id: z.string().nullable().optional(),
  point: z.number().int().default(0),
  last_visit_at: z.date(),
  card_method_id: z.string().optional(),
  questions_version: z.string().optional(),
})
export type User = z.infer<typeof User>

export const MatchCancelResult = z.object({
  user_id: z.string(),
  cast_id: z.string(),
  status: z.enum(['match_cancel_user', 'match_cancel_cast']),
})
export type MatchCancelResult = z.infer<typeof MatchCancelResult>

export const TalkResult = z.object({
  user_id: z.string(),
  cast_id: z.string(),
  status: z.enum(['talk_cancel_user', 'talk_cancel_cast', 'talk_end']),
  start_at: z.date(),
  end_at: z.date(),
  minutes: z.number().int(),
  positive: z.number().nullable(),
})
export type TalkResult = z.infer<typeof TalkResult>

export const tryCache = <T, >(fn: ()=> T, cache: (e: unknown)=> T): T => {
  try { return fn() }
  catch (e) { return cache(e) }
}

export const WebSocketClientMessage = z.union([
  z.object({type: z.literal('auth'), token: z.string()}),
  z.object({type: z.literal('reconnect'), token: z.string(), talkId: z.string()}),
  z.object({type: z.literal('talk_start')}),
  z.object({type: z.literal('extend_time'), sec: z.number().int()}),
  z.object({type: z.literal('ping')}),
])
export type WebSocketClientMessage = z.infer<typeof WebSocketClientMessage>

export type WebSocketSystemMessage = {
  type: 'match'
  name: string
  icon: string
  profile: Profile
  current_point: number | undefined
} |
{
  type: 'unmatch'
} |
{
  type: 'reconnecting'
} |
{
  type: 'talk',
  name: string
  icon: string
  channel: string
  profile: Profile | undefined
  token: string
  remaining_sec: number
  current_point: number | undefined
} |
{
  type: 'talk_end',
  reason: 'time over'
  channel: string
} |
{
  type: 'talk_end',
  reason: 'cancel'
  current_point: number | undefined
} |
{
  type: 'error',
  error_type: 'client websocket',
}